import { createSlice } from '@reduxjs/toolkit';

export const divestmentClubSlice = createSlice({
    name: 'divestmentClub',
    initialState: {
        dataToAction: { divestmentDate: '', salesPrice: '', divestmentParticipation: '' }
    },
    reducers: {
        selectDivestmentClub: (state, { payload }) => {
            state.dataToAction = payload;
        },
        unSelectDivestmentClub: (state) => {
            state.dataToAction = { name: '', date: '', url: '' }
        }
    }
});

export const { selectDivestmentClub, unSelectDivestmentClub } = divestmentClubSlice.actions;